import { css } from '@emotion/css';
import { Modal } from 'antd';

export interface Props {
  isOpen: boolean;
  onClose: () => void;
  url: string;
}

const ClobePDFModal = ({ url, isOpen, onClose }: Props) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      closable
      width={1200}
      bodyStyle={{
        padding: '24px 0',
        height: '80vh',
      }}
    >
      <iframe
        src={url}
        className={css`
          width: 100%;
          height: 100%;
        `}
      />
    </Modal>
  );
};

export default ClobePDFModal;
